/**
 *   人脸管理 接口列表
 *   接口地址: http://rap2.10niu.cn/organization/repository/editor?id=43&mod=413
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const faceCharges = {
	//  获取导入结果
	getImportResult(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_import_result`,
			params
		});
	},
	//  根据类型获取学校正在导入的进度
	getUploadingProgress(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_uploading_progress`,
			params
		});
	},
	//  批量操作学生人脸
	batchOperationStudentFace(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/face-manage/v1/batch_operation_student_face`,
			data: qs.stringify(data)
		});
	},
	//  获取学校可用人脸数
	getSchoolFaceUnusedCount(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_school_face_unused_count`,
			params
		});
	},
	//  变动记录
	getChangeList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_change_list`,
			params
		});
	},
	//  开启/关闭代理商人脸管理功能
	changeAgentStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/face-manage/v1/change_agent_status`,
			data: qs.stringify(data)
		});
	},
	//  获取代理商列表
	getAgentList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_agent_list`,
			params
		});
	},
	//  开通/关闭学校人脸管理功能
	changeSchoolStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/face-manage/v1/change_school_status`,
			data: qs.stringify(data)
		});
	},
	//  获取学校列表
	getSchoolList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_school_list`,
			params
		});
	},
	//  获取代理是否开通人脸管理功能
	getAgentFaceStatus(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_agent_face_status`,
			params
		});
	},
	//  获取学校是否开启人脸管理
	getSchoolFaceStatus(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_school_face_status`,
			params
		});
	},
	//  新增学校人脸数量
	addSchoolFacecount(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/face-manage/v1/add_school_face_count`,
			data: qs.stringify(data)
		});
	},
	//  回收学校人脸数量
	recycleSchoolFaceCount(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/face-manage/v1/recycle_school_face_count`,
			data: qs.stringify(data)
		});
	},
	//  获取学校人脸管理使用情况
	getSchoolFaceCase(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_school_face_case`,
			params
		});
	},
	//  新增学生人脸数
	addStudentFaceCount(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/face-manage/v1/add_student_face_count`,
			data: qs.stringify(data)
		});
	},
	//  回收学生人脸数
	recycleStudentFaceCount(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/face-manage/v1/recycle_student_face_count`,
			data: qs.stringify(data)
		});
	},
	//  获取学校学生列表
	getStudentFaceList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_student_face_list`,
			params
		});
	},
	//  获取对象列表
	getObjectList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_object_list`,
			params
		});
	},
	//  根据类型获取人脸新增/退还记录
	getStudentCountRecordList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/face-manage/v1/get_student_count_record_list`,
			params
		});
	}
};

export default faceCharges;
